import Header from "../components/Header";
import TransactionTable from "../components/TransactionTable";

const Transactions = () => {
  return (
    <div>
      <Header />
      <TransactionTable />
    </div>
  );
};

export default Transactions;
